import React from "react";
import {store} from "../store";
import Success from "../svg/Success";
import BackToStart from "./BackToStart";

const Complete = () => {
    const globalState = React.useContext(store);
    const {balance} = globalState.state.account;

    return (
        <div>
            <Success/>
            <div className="message">
                <p style={{textAlign: "center"}}>
                    <span style={{display: "block", fontSize: "13px"}}>
                    Funds have been added to your account.
                    </span>
                    <strong>Your new balance is</strong>
                </p>
                <p style={{textAlign: "center", fontSize: "32px"}}>
                    ${balance}
                </p>
            </div>
            <div style={{textAlign: "center"}}>
                <BackToStart>Start Again</BackToStart>
            </div>
        </div>
    );
};

export default Complete;
